import { DateTime } from "luxon";
import { BillingItemType } from "@KassaroAB/shared/types/enums/BillingItemType";

const MONTHLY_MINIMUM_TYPES: BillingItemType[] = [
  BillingItemType.PACKAGE,
  BillingItemType.ADD_ON,
  BillingItemType.EXTRA_DEVICE,
  BillingItemType.PAYMENT_METHOD,
];

export const requiresMonthlyMinimumActive = (type: BillingItemType): boolean =>
  MONTHLY_MINIMUM_TYPES.includes(type);

export const addOneMonth = (isoDate: string): string | null =>
  DateTime.fromISO(isoDate).plus({ months: 1 }).toISODate() ?? null;

export const getMinimumActiveUntilDate = (
  type: BillingItemType,
  activeSince: string,
): string | null => {
  if (!requiresMonthlyMinimumActive(type)) {
    return null;
  }
  return addOneMonth(activeSince);
};

export const isDateBeforeMinimumActiveUntil = (
  type: BillingItemType,
  activeSince: string,
  date: string | null | undefined,
): boolean => {
  if (!date) {
    return false;
  }
  const minimumDate = getMinimumActiveUntilDate(type, activeSince);
  if (!minimumDate) {
    return false;
  }
  return date < minimumDate;
};

export const getNonAdminMinimumEndDate = (
  paidUntil: string | null | undefined,
  todayIso: string,
): string => {
  if (!paidUntil) {
    return todayIso;
  }
  return paidUntil > todayIso ? paidUntil : todayIso;
};

export const isEndDateBeforePaidUntil = (
  endDate: string | null | undefined,
  paidUntil: string | null | undefined,
): boolean => {
  if (!endDate || !paidUntil) {
    return false;
  }
  return endDate < paidUntil;
};
